import React, { forwardRef, useMemo } from 'react';
import { Virtuoso } from 'react-virtuoso';
import styled from 'styled-components';
import {
  MONTH_CONTENT_BOTTOM_SIDE_BORDER_COLOR,
  MONTH_SEPARATION_PADDING_HALF,
} from '../../constants';
import { Review } from './review';

const ReviewListContainer = styled.div`
  border-left: ${MONTH_SEPARATION_PADDING_HALF} solid
    ${MONTH_CONTENT_BOTTOM_SIDE_BORDER_COLOR};
  border-right: ${MONTH_SEPARATION_PADDING_HALF} solid
    ${MONTH_CONTENT_BOTTOM_SIDE_BORDER_COLOR};
  ${({ suppressLeftBorder }) =>
    !suppressLeftBorder ? '' : 'border-left: none;'}
  flex: 1
`;
const Scroller = styled.div`
  overflow-y: hidden !important;
  overflow-x: hidden !important;

  &:hover {
    overflow-y: scroll !important;
  }
`;

export function ReviewList({ reviews, monthIndex }) {
  const sortedReviews = useMemo(
    () => [...reviews].sort((a, b) => a.createdTs - b.createdTs),
    [reviews]
  );
  return (
    <ReviewListContainer suppressLeftBorder={monthIndex === 0}>
      <Virtuoso
        data={sortedReviews}
        components={{
          // eslint-disable-next-line react/display-name
          Scroller: forwardRef(({ style, ...props }, ref) => (
            <Scroller style={style} ref={ref} {...props} />
          )),
        }}
        itemContent={(index, review) => <Review data={review} index={index} />}
      />
    </ReviewListContainer>
  );
}
